import Vue from 'vue';
import Router from 'vue-router';

import {
  wrapInArray,
  getNumber,
} from '@/utils/common-utils';
import {
  get,
} from '@/utils/lodash';

import Store from '@/store';

import Providers from '@/views/provider/providers.vue';
import VueHtml2Canvas from 'vue-html2canvas';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
Vue.use(VueHtml2Canvas);


import userApi from '@/api/user';

Vue.use(Router);

function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

const router = new Router({

  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },

  mode: 'history',
  routes: [
    {
      path: '/:region(on|qc)?',
      name: 'home',
      component: lazyLoad('home/home'),
    },
    {
      path: '/login',
      name: 'Login',
      component: lazyLoad('user/login'),
    },
    {
      path: '/reset-password',
      name: 'Reset-Password',
      component: lazyLoad('user/reset-password'),
    },
    {
      path: '/account',
      name: 'Account',
      component: lazyLoad('user/account'),
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/account/profile',
      name: 'Profile',
      component: lazyLoad('user/profile'),
      meta: {
        authRequired: true,
      },
    },

    {
      path: '/account/sales',
      name: 'SalesHistory',
      component: lazyLoad('user/sales-history'),
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/products',
      name: 'products',
      component: lazyLoad('product/products'),
      props: route => ({
        page: getNumber(get(route.query, 'page'), 1),
        productTypesModel: route.query.inventory != null ? wrapInArray(route.query.inventory) : [],
        productInventoryModel: route.query.inventory != null ? wrapInArray(route.query.inventory) : [],
        availabilityModel: route.query.inventory != null ? wrapInArray(route.query.inventory) : localStorage.getItem("countryCode") == 'ON' ? ['LCBO', 'PI', 'MERCH_TORONTO'] :['IP', 'SAQ', 'Brouhh', 'MERCH_MTL'],
        attributesModel: route.query.a != null ? wrapInArray(route.query.a) : [],
        countriesModel: route.query.c != null ? wrapInArray(route.query.c) : [],
        regionsModel: route.query.r != null ? wrapInArray(route.query.r) : [],
        minPriceModel: getNumber(get(route.query, 'min')),
        maxPriceModel: getNumber(get(route.query, 'max')),
        setProductTypes: route.query.type != null ? wrapInArray(route.query.type) : [],
      }),
    },
    {
      path: '/products/:slug',
      name: 'product',
      component: lazyLoad('product/product'),
      props: route => ({
        slug: get(route.params, 'slug', null),
        // puid: get(route.query, 'puid', null),
        id: get(route.query, 'id', null),
      }),
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: lazyLoad('about-us/about-us'),
      props: route => ({
        slug: get(route.params, 'slug', null),
        puid: get(route.query, 'puid', null),
      }),
    },
    {
      path: '/providers',
      name: 'providers',
      component: Providers,
      props: route => ({
        type: route.query.type,
        page: getNumber(get(route.query, 'page'), 1),
        attributesModel: route.query.a != null ? wrapInArray(route.query.a) : [],
        countriesModel: route.query.c != null ? wrapInArray(route.query.c) : [],
        regionsModel: route.query.r != null ? wrapInArray(route.query.r) : [],
        textModel: route.query.t,
      }),
    },
    {
      path: '/providers/:slug',
      name: 'provider',
      component: lazyLoad('provider/provider'),
      props: route => ({
        slug: get(route.params, 'slug', null),
      }),
    },
    {
      path: '/blogs',
      name: 'blogs',
      component: lazyLoad('blog/blogs'),
      props: route => ({
        page: getNumber(get(route.query, 'page'), 1),
        blogTypesModel: route.query.type != null ? wrapInArray(route.query.type) : [],
        attributesModel: route.query.a != null ? wrapInArray(route.query.a) : [],
        // authorsModel: route.query.u != null ? wrapInArray(route.query.u) : [],
        // countriesModel: route.query.c != null ? wrapInArray(route.query.c) : [],
        // regionsModel: route.query.r != null ? wrapInArray(route.query.r) : [],
        setDefaultType: route.query.defaultType != null || get(route.params, 'type', null) != null ? wrapInArray(route.query.defaultType) : [],
      }),
    },
    {
      path: '/blogs/:id',
      name: 'blog',
      component: lazyLoad('blog/blog'),
      props: route => ({
        slug: get(route.params, 'slug', null),
        id: get(route.params, 'id', null),
      }),
    },
    {
      path: '/subscriptions',
      name: 'subscription',
      component: lazyLoad('subscription/subscriptions'),
    },
    {
      path: '/global-search',
      name: 'globalSearch',
      component: lazyLoad('global-search/global-search'),
      props: route => ({
        text: route.query.t,
        activeTabType: route.query.activeTabType,
        activeCurrentPage: route.query.activeCurrentPage && parseInt(route.query.activeCurrentPage, 10),
      }),
    },
    {
      path: '/shopping-cart',
      name: 'shoppingCart',
      component: lazyLoad('shopping-cart/shopping-cart'),
    },
    {
      path: '/shopping-cart-empty',
      name: 'shoppingCartEmpty',
      component: lazyLoad('shopping-cart/shopping-cart-empty'),
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: lazyLoad('checkout/checkout'),
    },
    {
      path: '/checkout/confirmation',
      name: 'checkoutConfirmation',
      component: lazyLoad('checkout/checkout-confirmation'),
    },
    {
      path: '/not-found',
      alias: '*',
      name: 'notFound',
      component: lazyLoad('not-found/not-found'),
      props: route => ({
        type: route.query.type,
      }),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: lazyLoad('user/forgot-password'),
      props: route => ({
        slug: get(route.params, 'slug', null),
        puid: get(route.query, 'puid', null),
      }),
    },
    {
      path: '/faq',
      name: 'faq',
      component: lazyLoad('faq/faq'),
    },
    {
      path: '/services',
      name: 'services',
      component: lazyLoad('faq/services'),
    },
    {
      path: '/understand-product',
      name: 'understand-product',
      component: lazyLoad('faq/understand-product'),
    },
    {
      path: '/orders-deliveries',
      name: 'orders-deliveries',
      component: lazyLoad('faq/orders-deliveries'),
    },
    {
      path: '/pricing-policy',
      name: 'pricing-policy',
      component: lazyLoad('faq/pricing-policy'),
    },
    {
      path: '/membres',
      name: 'membre',
      component: lazyLoad('subscription/membre'),
    },
    {
      path: '/discovery',
      name: 'discovery',
      component: lazyLoad('subscription/discovery')
    },
  ],
});

const getCurrentUser = () => {
  const accessToken = localStorage.getItem('access-token') || sessionStorage.getItem('access-token');

  if (accessToken && (get(Store, 'state.user.user.id') == null || localStorage.user != null || sessionStorage.user != null)) {
    const userId = localStorage.getItem('user') != null ? JSON.parse(localStorage.user).user.id : sessionStorage.getItem('user') != null ? JSON.parse(sessionStorage.user).user.id : null;
    if (userId) {
      return new Promise((resolve, reject) => { // Return a new Promise
        userApi.findById(userId)
          .then((user) => {
            Store.dispatch('user/setUserProfile', user)
              .then(() => { // Wait for the action to complete (if it returns a Promise)
                resolve(); // Resolve the Promise after the store is updated
              })
              .catch((storeError) => {
                reject(storeError);
              });
          })
          .catch((apiError) => {
            reject(apiError);
          });
      });
    } else {
      Store.dispatch('user/logout');
      Store.dispatch('shoppingCart/emptyShoppingCart');
      Store.dispatch('user/createTempUser');
      return Promise.reject('No user ID found');
    }
  }
  return Promise.resolve(); // Resolve immediately if no token or user in store
};

router.beforeEach(async (to, from, next) => {
  

  if (to && to.meta && to.meta.authRequired) {

    const accessToken = localStorage.getItem('access-token') || sessionStorage.getItem('access-token');

    if (!accessToken) {
      next({
        path: '/login',
        query: {
          redirect: to,
        },
      });
      return;
    }

    // Attempt automatic login if token exists
    try {
      await getCurrentUser(to, from, next); // getCurrentUser now returns a Promise
      next(); // If getCurrentUser succeeds, proceed to the route
    } catch (error) {
      // If automatic login fails (e.g., invalid token), redirect to login
      next({
        path: '/login',
        query: {
          redirect: to,
        },
      });
    }
  } else {
    // For routes that don't require authentication, simply proceed
    next();
  }
});

export default router;
